import { Typography } from "@shared/ui.primitives";

export const Description = ({ text }: { text: string }) => {
  if (!text) return null;
  return (
    <Typography variant="subheader-6" colour="primary-medium">
      {text}
    </Typography>
  );
};
